(function () {
        const FRAME_ONLY = 'Frame Only';
        const NO_DESK_TOP = 'No Desk Top';
        const SIZE_PREFIX = 'Desk Top Size';
        const COLOUR_PREFIX = 'Desk Top Colour';

        let syncing = false;

        function clean(v) {
        return String(v || '').replace(/\s+/g, ' ').trim().toLowerCase();
        }

        function allRadios() {
        return Array.from(document.querySelectorAll('variant-selects input[type="radio"]'));
        }

        function optionRadios(prefix) {
        return allRadios().filter(function (input) {
            return clean(input.name).startsWith(clean(prefix));
        });
        }

        function checked(prefix) {
        return optionRadios(prefix).find(function (input) {
            return input.checked;
        });
        }

        function labelFor(input) {
        return input ? document.querySelector('label[for="' + CSS.escape(input.id) + '"]') : null;
        }

        function hideNoDeskTop() {
        optionRadios(COLOUR_PREFIX).forEach(function (input) {
        if (clean(input.value) !== clean(NO_DESK_TOP)) return;

        const label = labelFor(input);

        input.classList.add('ss-hidden-desktop-colour');

        if (label) {
            label.classList.add('ss-hidden-desktop-colour');
        }
        });
    }

        function selectRadio(input) {
        if (!input) return false;

        input.checked = true;
        input.click();

        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));

        return true;
        }

        function selectValue(prefix, value) {
        const input = optionRadios(prefix).find(function (radio) {
            return clean(radio.value) === clean(value);
        });

        return selectRadio(input);
        }

        function selectFirstExcept(prefix, excludedValue) {
        const input = optionRadios(prefix).find(function (radio) {
            return clean(radio.value) !== clean(excludedValue) &&
                !radio.disabled &&
                !radio.classList.contains('disabled');
        });

        return selectRadio(input);
        }

        function sync(changed) {
        if (syncing) return;
        syncing = true;

        const size = checked(SIZE_PREFIX);
        const colour = checked(COLOUR_PREFIX);

        const sizeValue = size ? size.value : '';
        const colourValue = colour ? colour.value : '';

        console.log('[Desk Sync]', {
            changed,
            sizeValue,
            colourValue,
            sizeRadios: optionRadios(SIZE_PREFIX).map(i => i.value),
            colourRadios: optionRadios(COLOUR_PREFIX).map(i => i.value)
        });

        if (changed === SIZE_PREFIX && clean(sizeValue) === clean(FRAME_ONLY)) {
            selectValue(COLOUR_PREFIX, NO_DESK_TOP);
        }

        if (
            changed === SIZE_PREFIX &&
            clean(sizeValue) !== clean(FRAME_ONLY) &&
            clean(colourValue) === clean(NO_DESK_TOP)
        ) {
            selectFirstExcept(COLOUR_PREFIX, NO_DESK_TOP);
        }

        if (
            changed === COLOUR_PREFIX &&
            clean(colourValue) !== clean(NO_DESK_TOP) &&
            clean(sizeValue) === clean(FRAME_ONLY)
        ) {
            selectFirstExcept(SIZE_PREFIX, FRAME_ONLY);
        }

        if (!changed) {
            if (clean(sizeValue) === clean(FRAME_ONLY)) {
            selectValue(COLOUR_PREFIX, NO_DESK_TOP);
            } else if (clean(colourValue) === clean(NO_DESK_TOP)) {
            selectFirstExcept(COLOUR_PREFIX, NO_DESK_TOP);
            }
        }

        hideNoDeskTop();

        setTimeout(function () {
            syncing = false;
        }, 250);
        }

        function init() {
        hideNoDeskTop();
        sync(null);
        }

        document.addEventListener('change', function (event) {
        if (!event.target.matches('variant-selects input[type="radio"]')) return;

        const name = clean(event.target.name);

        if (name.startsWith(clean(SIZE_PREFIX))) {
            sync(SIZE_PREFIX);
        }

        if (name.startsWith(clean(COLOUR_PREFIX))) {
            sync(COLOUR_PREFIX);
        }
        }, true);

        setTimeout(init, 500);
    })();